/**
 * Comprehensive EVM Chain Configuration
 * Supports all major EVM-compatible chains with proper metadata
 */

export const EVM_CHAINS = {
  // Mainnets
  1: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_ETH_RPC || 'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    explorer: 'https://etherscan.io',
    chainId: 1,
  },
  56: {
    name: 'BNB Smart Chain',
    symbol: 'BNB',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_BSC_RPC || 'https://bsc-dataseed.binance.org/',
    explorer: 'https://bscscan.com',
    chainId: 56,
  },
  137: {
    name: 'Polygon',
    symbol: 'MATIC',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_POLYGON_RPC || 'https://polygon-rpc.com/',
    explorer: 'https://polygonscan.com',
    chainId: 137,
  },
  42161: {
    name: 'Arbitrum One',
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_ARBITRUM_RPC || 'https://arb1.arbitrum.io/rpc',
    explorer: 'https://arbiscan.io',
    chainId: 42161,
  },
  10: {
    name: 'Optimism',
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_OPTIMISM_RPC || 'https://mainnet.optimism.io',
    explorer: 'https://optimistic.etherscan.io',
    chainId: 10,
  },
  43114: {
    name: 'Avalanche',
    symbol: 'AVAX',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_AVALANCHE_RPC || 'https://api.avax.network/ext/bc/C/rpc',
    explorer: 'https://snowtrace.io',
    chainId: 43114,
  },
  250: {
    name: 'Fantom',
    symbol: 'FTM',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_FANTOM_RPC || 'https://rpc.ftm.tools/',
    explorer: 'https://ftmscan.com',
    chainId: 250,
  },
  8453: {
    name: 'Base',
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_BASE_RPC || 'https://mainnet.base.org',
    explorer: 'https://basescan.org',
    chainId: 8453,
  },
  324: {
    name: 'zkSync Era',
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_ZKSYNC_RPC || 'https://mainnet.era.zksync.io',
    explorer: 'https://explorer.zksync.io',
    chainId: 324,
  },
  59144: {
    name: 'Linea',
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_LINEA_RPC || 'https://rpc.linea.build',
    explorer: 'https://lineascan.build',
    chainId: 59144,
  },
  534352: {
    name: 'Scroll',
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_SCROLL_RPC || 'https://rpc.scroll.io',
    explorer: 'https://scrollscan.com',
    chainId: 534352,
  },
  1101: {
    name: 'Polygon zkEVM',
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_POLYGON_ZKEVM_RPC || 'https://zkevm-rpc.com',
    explorer: 'https://zkevm.polygonscan.com',
    chainId: 1101,
  },
  5000: {
    name: 'Mantle',
    symbol: 'MNT',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_MANTLE_RPC || 'https://rpc.mantle.xyz',
    explorer: 'https://explorer.mantle.xyz',
    chainId: 5000,
  },
  81457: {
    name: 'Blast',
    symbol: 'ETH',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_BLAST_RPC || 'https://rpc.blast.io',
    explorer: 'https://blastscan.io',
    chainId: 81457,
  },
  100: {
    name: 'Gnosis',
    symbol: 'xDAI',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_GNOSIS_RPC || 'https://rpc.gnosischain.com',
    explorer: 'https://gnosisscan.io',
    chainId: 100,
  },
  42220: {
    name: 'Celo',
    symbol: 'CELO',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_CELO_RPC || 'https://forno.celo.org',
    explorer: 'https://celoscan.io',
    chainId: 42220,
  },
  1284: {
    name: 'Moonbeam',
    symbol: 'GLMR',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_MOONBEAM_RPC || 'https://rpc.api.moonbeam.network',
    explorer: 'https://moonscan.io',
    chainId: 1284,
  },
  1285: {
    name: 'Moonriver',
    symbol: 'MOVR',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_MOONRIVER_RPC || 'https://rpc.api.moonriver.moonbeam.network',
    explorer: 'https://moonriver.moonscan.io',
    chainId: 1285,
  },
  1666600000: {
    name: 'Harmony',
    symbol: 'ONE',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_HARMONY_RPC || 'https://api.harmony.one',
    explorer: 'https://explorer.harmony.one',
    chainId: 1666600000,
  },
  25: {
    name: 'Cronos',
    symbol: 'CRO',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_CRONOS_RPC || 'https://evm.cronos.org',
    explorer: 'https://cronoscan.com',
    chainId: 25,
  },
  8217: {
    name: 'Klaytn',
    symbol: 'KLAY',
    decimals: 18,
    rpcUrl: process.env.REACT_APP_KLAYTN_RPC || 'https://public-node-api.klaytnapi.com/v1/cypress',
    explorer: 'https://scope.klaytn.com',
    chainId: 8217,
  },
};

/**
 * Get chain configuration for wallet_addEthereumChain
 */
export const getChainConfig = (chainId) => {
  const chain = EVM_CHAINS[chainId];
  if (!chain) {
    throw new Error(`Unsupported chain ID: ${chainId}`);
  }

  return {
    chainId: `0x${chainId.toString(16)}`,
    chainName: chain.name,
    nativeCurrency: {
      name: chain.symbol,
      symbol: chain.symbol,
      decimals: chain.decimals,
    },
    rpcUrls: [chain.rpcUrl],
    blockExplorerUrls: [chain.explorer],
  };
};

/**
 * Get RPC URL for a chain
 */
export const getRpcUrl = (chainId) => {
  const chain = EVM_CHAINS[chainId];
  return chain?.rpcUrl || null;
};

/**
 * Get explorer URL for a chain
 */
export const getExplorerUrl = (chainId) => {
  const chain = EVM_CHAINS[chainId];
  return chain?.explorer || 'https://etherscan.io';
};

/**
 * Check if a chain is supported
 */
export const isChainSupported = (chainId) => {
  return chainId in EVM_CHAINS;
};

/**
 * Get all supported chain IDs
 */
export const getSupportedChainIds = () => {
  return Object.keys(EVM_CHAINS).map(Number);
};

